import { getRelationships } from './getRelationships'

export const getEntities = (entities: any) => {
  if (!entities) {
    return []
  }

  return entities.map((entity: any) => getRelationships(entity.id))
}
